import { render, staticRenderFns } from "./SubjectOptionsOld.vue?vue&type=template&id=390394a5&scoped=true"
import script from "./SubjectOptionsOld.vue?vue&type=script&lang=js"
export * from "./SubjectOptionsOld.vue?vue&type=script&lang=js"
import style0 from "./SubjectOptionsOld.vue?vue&type=style&index=0&id=390394a5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390394a5",
  null
  
)

export default component.exports